import { 
  // Language,
  LoginButtons, Navigation, UserName } from './fragments';
import { StyledFlexContainer } from './styled';

export const DesktopMenu = ({isAuth, routes})=> (
  <StyledFlexContainer>
    <Navigation routes={routes}/>
    {/*  TO DO*/}
    {/*<Language/>*/}
    {isAuth() ? <UserName/> : null }
    <LoginButtons isAuth={isAuth}/>
  </StyledFlexContainer>
);
